import React, { Component } from 'react';
const iconMenu = require('../../../../public/img/tampa/ui/icon-menu.png');

class MenuButtonTampa extends Component {
  renderBackButton = () => {
    return (
      <div>
        <div style={{ position: "absolute", marginLeft: '.3vh', top: 0, height: "2vh", width: "100%" }}>
          <span style={{ position: "absolute", top: "0.5vh", fontSize: '.96vh', color: '#143e77', right: "1.15740740740740740741vw" }}>MENU</span>
        </div>
        <div style={{ position: "absolute", marginLeft: '.3vh', marginTop: "0.5vh", top:"1.8vh", width:"100%", height:"2vh" }}>
          <img className="fliph" alt="back" style={{ position: "absolute", width: '2vh', height: '1.2vh', marginLeft: "0.208333333vh", right:"1.85185185185185185185vw" }} src={iconMenu} />
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.mode === "video" ?
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, top: this.props.top, borderRadius: this.props.border, left: this.props.left }}>
            {this.renderBackButton()}
          </div>
          :
          <div onMouseDown={() => this.props.clickAction()} style={{ position: 'fixed', height: this.props.height, width: this.props.width, backgroundColor: 'white', top: this.props.top, borderTopRightRadius: this.props.border, borderBottomRightRadius: this.props.border }}>
            <div>
              {this.renderBackButton()}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default MenuButtonTampa;


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/MenuButtonTampa.jsx